import { AfterViewInit, ChangeDetectionStrategy, Component, HostListener, OnInit, QueryList, signal, Signal, ViewChildren } from '@angular/core';
import { ApplicationService } from 'src/app/services/application.service';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { SpotlightService } from 'src/app/services/spotlight.service';
import { StaticContentService } from 'src/app/services/staticcontent.service';
import { ShadowPopoverDirective } from '../../directives/shadow-popover.directive';
import { PetDTO, SpotlightEvent, StaticContent } from '../../dto';
import { PetService } from '../../services/pet.service';
import { TutorialService } from '../../services/tutorial.service';
import { PageComponent } from '../base.component';
import { LoginModalComponent } from '../login-modal/login-modal.component';

@Component({
    selector: 'app-mainpage',
    templateUrl: './mainpage.component.html',
    styleUrls: ['./mainpage.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainpageComponent extends PageComponent implements OnInit, AfterViewInit {

    public static route = 'mainpage';
    activeUserPetsSignal: Signal<PetDTO[]>;
    // Set inside the async subscribes below (external service subjects), not template-bound
    // handlers - need to be signals for OnPush to see the updates.
    protected latestAlert = signal<StaticContent>(undefined);
    newsSignal: Signal<StaticContent[]>;
    protected displayedSpotlightEvent = signal<SpotlightEvent>(undefined);
    protected activeSpotlightPool = signal<SpotlightEvent[]>([]);
    @ViewChildren('tut1') tutorial1: QueryList<ShadowPopoverDirective>;



    constructor(protected coreAppService: ApplicationService, private petService: PetService,
        private newsService: StaticContentService, private tutorialService: TutorialService, private spotlightService: SpotlightService,
        public featureFlagService: FeatureFlagService) {

        super(coreAppService.authService, coreAppService.uiStateService);
        this.activeUserPetsSignal = this.petService.activeUserPetsSignal;
        this.newsSignal = this.newsService.allNewsSignal;
        this.subscribe(this.newsService.latestAlert$, (val) => { this.latestAlert.set(val) });
        this.subscribe(this.spotlightService.activeSpotlights$, (pool) => {
            this.activeSpotlightPool.set(pool);
            this.displayedSpotlightEvent.set(this.spotlightService.selectDisplayEvent(pool));
        });

    }

    @HostListener('window:resize')
    onResize(): void {
        this.coreAppService.uiStateService.isMobile.set(window.innerWidth <= 768);
    }

    ngOnInit(): void {
        this.onResize();
    }

    ngAfterViewInit(): void {
        if (!this.tutorialService.tutorialComplete) {
            if (this.tutorial1.length > 0) {
                this.tutorialService.addTutorialSections([this.tutorial1.first]);
            } else {
                this.subscriptions.push(this.tutorial1.changes.subscribe((x: QueryList<ShadowPopoverDirective>) => {
                    this.tutorialService.addTutorialSections([x.first]);
                }));
            }
        }

    }

    openModal() {
        this.coreAppService.modalService.open(LoginModalComponent);
    }
}
